import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useState } from "react"
import { AllAlertTargetGroupsQueryVariables, useAllAlertTargetGroupsQuery } from "../../graphql"
import { AlertTargetGroupsList } from "./AlertTargetGroupsList"

export const AllAlertTargetGroups: React.FC = () => {
	const [pagination, setPagination] = useState<AllAlertTargetGroupsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useAllAlertTargetGroupsQuery({
		variables: { pagination },
	})

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.allAlertTargetGroups.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allAlertTargetGroups ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading alert target groups</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allAlertTargetGroups.alertTargetGroups && data.allAlertTargetGroups.alertTargetGroups.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allAlertTargetGroups.alertTargetGroups.length || 0} alert target group
						{(data.allAlertTargetGroups.alertTargetGroups.length || 0) > 1 ? "s" : ""}
					</Text>

					<AlertTargetGroupsList alertTargetGroups={data.allAlertTargetGroups.alertTargetGroups} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more alert target groups</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any alert target groups.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
